import { render, staticRenderFns } from "./RowBlockInvoiceForClient.vue?vue&type=template&id=2a35266c&"
import script from "./RowBlockInvoiceForClient.vue?vue&type=script&lang=js&"
export * from "./RowBlockInvoiceForClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports